const _excluded = ["placement", "show", "container", "target", "renderTarget", "renderOverlay"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import Portal from '@adsk/alloy-react-portal';
import { PLACEMENTS, VARIANTS } from './consts';
import useOverlay from './hooks/useOverlay';
import Arrow from './layout/Arrow';
import Blank from './layout/Blank';
import Body from './layout/Body';
import Container from './layout/Container';
import Target from './layout/Target';
/**
 * React Overlay wrapper component for useOverlay
 */
const Overlay = _ref => {
  let {
      placement: placementProp = PLACEMENTS.BOTTOM,
      show: showProp,
      container = document.body,
      target: targetRef,
      renderTarget,
      renderOverlay
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const target = useForwardedRef(targetRef || null);
  const {
    show,
    placement,
    targetProps,
    overlayProps,
    arrowProps,
    onHide,
    handleToggle
  } = useOverlay(_objectSpread({
    placement: placementProp,
    show: showProp,
    target
  }, props));
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTarget === null || renderTarget === void 0 ? void 0 : renderTarget({
    show,
    handleToggle,
    targetProps
  }), renderOverlay && show ? /*#__PURE__*/React.createElement(Portal, {
    container: container
  }, renderOverlay({
    placement,
    handleHide: onHide,
    targetProps,
    overlayProps,
    arrowProps
  })) : null);
};
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * whether the popover is showed or not. should be sent only for
   * controlled elements
   */
  show: PropTypes.bool,
  /**
   * callback to be called on show
   */
  onShow: PropTypes.func,
  /**
   * callback to be called on hide
   */
  onHide: PropTypes.func,
  /**
   * delay before show in milliseconds
   */
  delayShow: PropTypes.number,
  /**
   * delay before hide in milliseconds
   */
  delayHide: PropTypes.number,
  /** overlay position according to Overlay placements. */
  placement: PropTypes.oneOf(Object.values(useOverlay.PLACEMENTS)),
  /** target element ref (get/set).  */
  target: PropTypes.object,
  /** overlay ref to overlay dom element. */
  overlayRef: PropTypes.any,
  /** Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay. */
  rootClose: PropTypes.bool,
  /** Dependency to pass to usePopper's useLayoutEffect hook */
  layoutDependency: PropTypes.any,
  /** Container is Overlay Portal location */
  container: PropTypes.object,
  /**  render prop for Target:
   *    <Target
          show={show}
          handleToggle={handleToggle}
          targetProps={targetProps}
        />
   */
  renderTarget: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /** render prop for Overlay:
   * <Overlay
      placement={placement}
      handleHide={handleHide}
      targetProps={targetProps}
      overlayProps={overlayProps}
      arrowProps={arrowProps}
    />
   */
  renderOverlay: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
export default Object.assign(Overlay, {
  VARIANTS,
  PLACEMENTS,
  Target,
  Container,
  Body,
  Blank,
  Arrow
});
//# sourceMappingURL=Overlay.js.map